import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../contexts/DataContext';
import PropertyForm from './PropertyForm';
import PropertyList from './PropertyList';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPlus } = FiIcons;

const PropertyManager = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingProperty, setEditingProperty] = useState(null);
  const { properties } = useData();

  const handleEdit = (property) => {
    setEditingProperty(property);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingProperty(null);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-800">My Properties</h2>
          <p className="text-sm text-gray-500">Manage your portfolio</p>
        </div>
        <motion.button
          onClick={() => setShowForm(true)}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl shadow-lg shadow-blue-200 transition-all duration-200"
        >
          <SafeIcon icon={FiPlus} />
          <span className="font-medium">Add Property</span>
        </motion.button>
      </div>

      {showForm ? (
        <PropertyForm property={editingProperty} onClose={handleCloseForm} />
      ) : (
        <PropertyList onEdit={handleEdit} />
      )}
    </div>
  );
};

export default PropertyManager;